module.exports = __webpack_public_path__ + "img/magnifying-glass-tilted.16dfb4dd.png";